<template>
  <b-card-code>
    <validation-observer ref="formObserver">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label>Recipient Name</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Recipient Name">
                <b-form-input v-model="form.recipient_name" placeholder="Enter recipient name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>Recipient Email</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required|email" name="Recipient Email">
                <b-form-input v-model="form.recipient_email" type="email" placeholder="Enter recipient email" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>User (optional)</label>
              <v-select
                v-model="selectedUser"
                :options="users"
                label="name"
                :reduce="(item) => item"
                placeholder="Select user"
                @input="onUserSelect"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>Subject</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Subject">
                <b-form-input v-model="form.subject" placeholder="Agreement subject" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label>Agreement Content</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Agreement Content">
                <b-form-textarea
                  v-model="form.content"
                  rows="12"
                  placeholder="Enter agreement HTML or text content"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-2">
          <b-button variant="outline-secondary" class="mr-1" @click="$router.push('/setup/digital-agreements')">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="submitting">
            <b-spinner v-if="submitting" small class="mr-1" />
            Send Agreement
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { BForm, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner } from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@/components/axios'
import { sendDigitalAgreement } from '@/api/digitalAgreement'

export default {
  name: 'SendDigitalAgreement',
  components: {
    BCardCode,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      submitting: false,
      users: [],
      selectedUser: null,
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
      form: {
        recipient_name: '',
        recipient_email: '',
        user_id: null,
        subject: '',
        content: '',
      },
    }
  },
  mounted() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      try {
        const response = await axios({
          method: 'GET',
          url: `${this.baseApi}/getUsers`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        this.users = response.data?.data || []
      } catch (err) {
        console.error('Failed to load users', err)
      }
    },
    onUserSelect(user) {
      if (!user) {
        this.form.user_id = null
        return
      }
      this.form.user_id = user.id
      if (!this.form.recipient_name) this.form.recipient_name = user.name || user.fullname || ''
      if (!this.form.recipient_email) this.form.recipient_email = user.email || ''
    },
    async submitForm() {
      const valid = await this.$refs.formObserver.validate()
      if (!valid) return

      this.submitting = true
      try {
        await sendDigitalAgreement(this.form)
        this.$bvToast.toast('Digital agreement sent successfully.', {
          title: 'Success',
          variant: 'success',
        })
        this.$router.push('/setup/digital-agreements')
      } catch (err) {
        this.$bvToast.toast(err.response?.data?.message || 'Failed to send agreement.', {
          title: 'Error',
          variant: 'danger',
        })
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
